import { render, staticRenderFns } from "./FlightClose.vue?vue&type=template&id=2f054fa7&"
import script from "./FlightClose.vue?vue&type=script&lang=js&"
export * from "./FlightClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports